import { IconCheckmark, IconCloseCircle } from 'assets/img';
import { LwButton } from 'redesign';
import { FormProvider } from 'react-hook-form';
import { Box, Card, Modal, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DocumentSignDialogContentProps } from './document-sign-dialog-content.types';
import { SignDocumentDialogHeader } from './components/sign-document-dialog-header/sign-document-dialog-header';
import { SignDocumentDialogBody } from './components/sign-document-dialog-body/sign-document-dialog-body';
import { useDocumentDialogSign } from '../../../table/hooks/use-document-dialog-sign';

export const DocumentSignDialogContent = ({
  isOpen,
  onClose,
  documentId,
  documentData,
}: DocumentSignDialogContentProps) => {
  const { t } = useTranslation(['web-common']);
  const {
    firstName,
    lastName,
    infix,
    email,
    status,
    documentName,
    documentType,
    payrollTaxEnabled,
    workerId,
  } = documentData;
  const { methods, handleSubmit, isLoading } = useDocumentDialogSign(
    documentId,
    onClose,
    documentData.formDataModel,
    documentData.contractMinutes ?? 0,
    workerId
  );

  return (
    <Modal open={isOpen} onClose={onClose}>
      <DialogLayout>
        <Box>
          <SignDocumentDialogHeader
            onClose={onClose}
            firstName={firstName}
            lastName={lastName}
            infix={infix}
            email={email}
            documentName={documentName}
            documentType={documentType}
          />
          <FormProvider {...methods}>
            <SignDocumentDialogBody
              payrollTaxEnabled={payrollTaxEnabled}
              selectedDocumentModel={documentData.formDataModel['actions']['issuer_sign']}
              status={status}
            />
          </FormProvider>
        </Box>
        <ButtonBigWrap>
          <ButtonWrap>
            <LwButton
              onClick={handleSubmit}
              iconColorMode="stroke"
              color="primary"
              disabled={isLoading || status !== 'Pending'}
              isLoading={isLoading}
              startIcon={<IconCheckmark />}
            >
              {t('buttons.accept', { ns: 'web-common' })}
            </LwButton>
            <LwButton
              onClick={onClose}
              iconColorMode="stroke"
              color="secondary"
              startIcon={<IconCloseCircle />}
            >
              {t('buttons.cancel', { ns: 'web-common' })}
            </LwButton>
          </ButtonWrap>
        </ButtonBigWrap>
      </DialogLayout>
    </Modal>
  );
};

export const DialogLayout = styled(Card)(({ theme }) => ({
  height: theme.spacing(160),
  maxWidth: theme.spacing(200),
  width: theme.spacing(200),
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: `translate(-50%, -50%)`,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(4),
  justifyContent: 'space-between',
}));

const FlexRowBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
}));

const ButtonBigWrap = styled(FlexRowBox)(({ theme }) => ({
  marginBottom: theme.spacing(8),
  marginTop: theme.spacing(5),
  justifyContent: 'center',
}));

const ButtonWrap = styled(FlexRowBox)(({ theme }) => ({
  justifyContent: 'space-around',
  gap: theme.spacing(4),
}));
